import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0B0B0D] border-t border-[#1E3A8A]/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 lg:gap-16">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <img
              src="https://public.readdy.ai/ai/img_res/a0dfe006-6179-422d-9045-deb7cf8a960a.png"
              alt="LOPES BUSINESS"
              className="h-12 w-auto object-contain mb-6"
            />
            <p className="font-sans text-sm font-light text-[#D1D5DB]/70 leading-relaxed max-w-sm">
              Consultoria estratégica esportiva, blindagem patrimonial e operações
              financeiras internacionais para atletas e empresários de alta performance.
            </p>
            <div className="flex items-center gap-4 mt-8">
              {[
                { icon: 'ri-instagram-line', href: '#' },
                { icon: 'ri-linkedin-box-line', href: '#' },
                { icon: 'ri-whatsapp-line', href: 'https://wa.me/qr/KP7ZNZ7ZYHHCN1' },
              ].map((social, i) => (
                <a
                  key={i}
                  href={social.href}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-[#C9A96E]/40 text-[#C9A96E] hover:bg-[#C9A96E] hover:text-[#0B0B0D] transition-all duration-300 cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-sans text-xs font-semibold tracking-[0.2em] uppercase text-[#C9A96E] mb-6">
              Navegação
            </h4>
            <ul className="flex flex-col gap-4">
              {[
                { label: 'Início', path: '/' },
                { label: 'Sobre', path: '/sobre' },
                { label: 'Serviços', path: '/servicos' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="font-sans text-sm font-light text-[#D1D5DB]/60 hover:text-[#C9A96E] transition-colors duration-300 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-sans text-xs font-semibold tracking-[0.2em] uppercase text-[#C9A96E] mb-6">
              Contato
            </h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#C9A96E] text-sm mt-0.5"></i>
                <span className="font-sans text-sm font-light text-[#D1D5DB]/60 leading-relaxed">
                  Brasil &amp; Operações Internacionais
                </span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-[#C9A96E] text-sm mt-0.5"></i>
                <span className="font-sans text-sm font-light text-[#D1D5DB]/60">
                  alessandro@lopesbusiness.com
                </span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-whatsapp-line text-[#C9A96E] text-sm mt-0.5"></i>
                <a
                  href="https://wa.me/qr/KP7ZNZ7ZYHHCN1"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="font-sans text-sm font-light text-[#D1D5DB]/60 hover:text-[#C9A96E] transition-colors duration-300 cursor-pointer"
                >
                  +55 (47) 99723-6779
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#1E3A8A]/20 mt-16 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-sans text-xs font-light text-[#D1D5DB]/40 tracking-wide">
            &copy; {currentYear} Lopes Business. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="font-sans text-xs font-light text-[#D1D5DB]/40 hover:text-[#C9A96E] transition-colors duration-300 cursor-pointer">
              Política de Privacidade
            </a>
            <span className="text-[#D1D5DB]/20">|</span>
            <a href="#" className="font-sans text-xs font-light text-[#D1D5DB]/40 hover:text-[#C9A96E] transition-colors duration-300 cursor-pointer">
              Termos de Uso
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
